export enum DeviceType {
  Ios = 'ios',
  Android = 'android',
  AppGallery = 'appgallery',
}

export enum AppStore {
  AppStore = 'appstore',
  GooglePlay = 'playstore',
  AppGallery = 'appgallery',
}

export enum AppDownloadPartner {
  MobileWeb = 'mobweb',
  Desktop = 'desktop',
}

export interface AppDownloadOptions {
  bannerName: string;
  deviceType?: DeviceType | null;
  partner?: AppDownloadPartner;
  trackDataLayer?: boolean;
}

export interface SourcebusterData {
  src?: string;
  mdm?: string;
  cmp?: string;
  cnt?: string;
  trm?: string;
}

export interface AppDownloadUtmQuery {
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
}
